import { routePaths, strCode } from "../../consts";

export const pathsConfig = [
  {
    title: strCode.NOTIFICATION_CENTER_TITLE,
    path: routePaths.NOTIFICATIONS
  },
  {
    title: strCode.FLEET_MANAGEMENT_NAV_BTN,
    path: routePaths.FLEET_MANAGEMENT
  }
];
